import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import moment from 'moment';
import MuiButton from 'material-ui/Button';
import classNames from 'classnames';
import { TimelineStatusLabelType } from '../../../../../constants/ComponentTypes';
import { isEnableFunction } from '../../../../../utils/componentUtils';

const styles = () => ({
  root: {
    padding: '25px',
    boxSizing: 'border-box',
    width: '100%',
  },

  buttonContainer: {
    width: '100%',
    marginTop: '30px 20px 10px',
  },

  timelineBtn: {
    color: '#1A65FF',
    fontSize: '11px',
    minWidth: 'unset',
    minHeight: 'unset',
    padding: '5px 10px',
    border: '1px solid #1A65FF',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    height: '30px',
  },

  isEnable: {
    cursor: 'pointer',
    '&:hover': {
      background: '#1A65FF',
      color: '#fff',
    },
  },

  emptyTimelineBtn: {
    background: '#ECEDEF',
    color: '#181819',
    fontSize: '11px',
    minWidth: 'unset',
    minHeight: 'unset',
    padding: '5px 10px',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    height: '30px',
  },
});

class LetterSendCount extends React.Component {
  render () {
    const { classes, statuses } = this.props;
    let approachList = [];
    if (statuses && statuses.length > 0) {
      approachList = statuses.filter(status => status.status_label_type === TimelineStatusLabelType.APPROACH && !!status.letter_order_address && !!status.letter_order_address.letter_order)
    }

    const isEnableGoToTimeline = isEnableFunction(this.props, 'goToTimeline');

    return (
      <div className={classes.root}>
        {(() => {
          if (approachList && approachList.length > 0) {
            return (
              <div className={classes.buttonContainer}>
              <MuiButton
                onClick={() => isEnableGoToTimeline && this.props.goToTimeline()}
                size="large"
                disabled={!isEnableGoToTimeline}
                style={{ width: "100%" }}
                className={classNames(classes.timelineBtn, isEnableGoToTimeline ? classes.isEnable : "")}
              >
                  {`これまでに${approachList.length}回レターを送付しました（最終：${moment(approachList.slice(-1)[0].letter_order_address.letter_order.instructed_at).format('YYYY年MM月DD日')}）`}
              </MuiButton>
            </div>
            );
          } else {
            return (
              <div className={classes.buttonContainer}>
                <MuiButton
                  style={{ width: "100%" }}
                  disabled={true}
                  className={classes.emptyTimelineBtn}>
                    まだレターを送付したことがありません。
                </MuiButton>
              </div>
            );
          }
        })()}
      </div>
    );
  }
}

LetterSendCount.propTypes = {
  classes: PropTypes.object.isRequired,
  statuses: PropTypes.array,
  goToTimeline: PropTypes.func,
}

PropTypes.defaultValue = {
  goToTimeline: null,
}

export default withStyles(styles)(LetterSendCount);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/ExecDetailItemDialog/sections/LetterSendCount.jsx